const normAux = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .trim();

export { normAux };

export const ESTADO_NOMBRES = [
  "De origen",
  "Nuevo a estrenar",
  "Para reformar",
  "Reformado",
  "Buen estado",
  "En construcción",
];

/** Opciones de Estado desde tabla auxiliar (orden BD). */
export function opcionesEstadoFicha(rows) {
  return [...(rows || [])]
    .filter((r) => r.id != null && r.activo !== false)
    .sort((a, b) => (Number(a.orden) || 99) - (Number(b.orden) || 99) || String(a.nombre || "").localeCompare(String(b.nombre || ""), "es"))
    .map((r) => ({ id: r.id, nombre: r.nombre }));
}

export function resolverEstadoId(nombre, rows) {
  const activos = rows || [];
  return (
    activos.find((r) => normAux(r.nombre) === normAux(nombre))?.id
    ?? null
  );
}

/** @deprecated Usar opcionesEstadoFicha */
export function ordenarEstadosInmueble(rows) {
  return opcionesEstadoFicha(rows);
}

const CALEF_EXCLUIDOS = [/^(no tiene|ninguno|sin|n\/a)$/i, /^(si|sí|tiene)$/i];

const CALEF_PRIORIDAD = [
  {
    label: "Splits",
    test: (n) => (n === "split" || n === "splits") && !n.includes("preinst"),
  },
  {
    label: "Conductos",
    test: (n) => (n === "conductos" || n.includes("conducto")) && !n.includes("preinst"),
  },
  {
    label: "Preinst. split",
    test: (n) => n.includes("preinst") && n.includes("split"),
  },
  {
    label: "Preinst. conductos",
    test: (n) => n.includes("preinst") && n.includes("conducto"),
  },
  {
    label: "Eléctrica",
    test: (n) => n === "electrica" || n.includes("electrica"),
  },
];

const AIRE_PRIORIDAD = [
  {
    label: "Split",
    test: (n) => (n === "split" || n === "splits") && !n.includes("preinst"),
  },
  {
    label: "Conductos",
    test: (n) => (n === "conductos" || n.includes("conducto")) && !n.includes("preinst"),
  },
  {
    label: "Preinst. split",
    test: (n) => n.includes("preinst") && n.includes("split"),
  },
  {
    label: "Preinst. conductos",
    test: (n) => n.includes("preinst") && n.includes("conducto"),
  },
];

const AIRE_EXCLUIDOS = [/^(no tiene|ninguno|sin|n\/a)$/i, /^(si|sí|tiene)$/i];

function pickSlot(rows, slot, usedIds) {
  const hit = rows.find((r) => {
    if (usedIds.has(r.id)) return false;
    return slot.test(normAux(r.nombre));
  });
  if (!hit) return null;
  usedIds.add(hit.id);
  return { ...hit, nombre: slot.label };
}

export function filtrarOpcionesCalefaccion(rows) {
  const activos = (rows || []).filter(
    (r) => r.activo !== false && !CALEF_EXCLUIDOS.some((re) => re.test(normAux(r.nombre))),
  );
  const used = new Set();
  const picked = CALEF_PRIORIDAD.map((slot) => pickSlot(activos, slot, used)).filter(Boolean);
  for (const r of activos) {
    if (!used.has(r.id)) picked.push(r);
  }
  return picked;
}

export function filtrarOpcionesAire(rows) {
  const activos = (rows || []).filter(
    (r) => r.activo !== false && !AIRE_EXCLUIDOS.some((re) => re.test(normAux(r.nombre))),
  );
  const used = new Set();
  const picked = AIRE_PRIORIDAD.map((slot) => pickSlot(activos, slot, used)).filter(Boolean);
  for (const r of activos) {
    if (!used.has(r.id)) picked.push(r);
  }
  return picked;
}
